import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  MediaSearchParams,
  MediaSearchResponse,
  searchMedia,
} from "#/lib/mediaApi";

export type UseMediaSearchResult = {
  data: MediaSearchResponse["data"];
  total: number;
  page: number;
  limit: number;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
};

export function useMediaSearch(
  params: MediaSearchParams
): UseMediaSearchResult {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: qk.mediaSearch(params),
    queryFn: () => searchMedia(params),
    staleTime: 30_000,
  });

  return {
    data: data?.data ?? [],
    total: data?.total ?? 0,
    page: data?.page ?? params.page ?? 1,
    limit: data?.limit ?? params.limit ?? 20,
    isLoading,
    isError,
    error,
    refetch,
  };
}

export default useMediaSearch;
